import type {CodeListId} from 'domainTypes';
import type {LinkedRoleCodeListId} from 'schemaDefinition/types/linkTypes';

export const isLinkedRoleCodeListId = (
  id: CodeListId | LinkedRoleCodeListId,
): id is LinkedRoleCodeListId => {
  return id.endsWith('.linkedRole');
};
